export const sendOauthTokenToRNApp = ({
  accessToken,
  refreshToken,
}: {
  accessToken: string;
  refreshToken: string;
}) => {
  (window as any).ReactNativeWebView.postMessage(
    JSON.stringify({accessToken, refreshToken}),
  );
};
